<ng-container>
  <nb-select
    [nbSpinner]="loadingAccounts"
    id="accountId"
    placeholder="{{ customPlaceholder || 'Select Account' }}"
    [formControl]="customFormControl"
    fullWidth
    size="small"
    [disabled]="disabled"
    [status]="
      customFormControl?.dirty
        ? customFormControl?.invalid
          ? 'danger'
          : 'success'
        : 'basic'
    "
  >
    <!-- All accounts options -->
    <nb-option *ngFor="let option of accountsOptions" [value]="option?.value">
      <div class="d-flex align-items-center justify-content-between w-100">
        <div>
          <nb-icon
            [icon]="option?.provider?.toLowerCase() + '-light'"
            pack="fci"
            class="provider-icon mr-2"
          >
          </nb-icon>
          <span>{{ option.label }}</span>
        </div>
        <nb-icon
          icon="info-outline"
          status="success"
          (click)="openAccDetailsPopover($event, option?.value)"
        ></nb-icon>
      </div>
    </nb-option>

    <!-- Create account option for VCS -->
    <nb-option>
      <div
        class="d-flex align-items-center justify-content-center w-100 py-2"
        nbPopoverTrigger="hover"
        [nbPopover]="vcsProviderPopover"
        (click)="onClickCreateNewOption($event)"
        *ngIf="accountType === 'VERSION_CONTROL'"
      >
        Create new account
        <nb-icon
          icon="create-account"
          pack="fci"
          class="ml-2 create-new-icon"
        ></nb-icon>
      </div>
    </nb-option>

    <!-- Create account option for CLOUD -->
    <nb-option>
      <div
        class="d-flex align-items-center justify-content-center w-100 py-2"
        nbPopoverTrigger="click"
        (click)="openNewAccountDialog($event)"
        *ngIf="accountType === 'CLOUD'"
      >
        Create new account
        <nb-icon
          icon="create-account"
          pack="fci"
          class="ml-2 create-new-icon"
        ></nb-icon>
      </div>
    </nb-option>
  </nb-select>
</ng-container>

<!-- Account details popover -->
<ng-template #userAccountPopover let-data let-ref="dialogRef">
  <app-organization-account-details
    [data]="data"
    [ref]="ref"
  ></app-organization-account-details>
</ng-template>

<!-- VCS providers popup -->
<ng-template #vcsProviderPopover let-data let-ref="dialogRef">
  <nb-card style="width: 16rem; max-height: 25rem" class="m-0">
    <nb-list>
      <nb-list-item
        *ngFor="let vcsProvider of vcsProvidersList"
        class="d-flex align-items-center border-bottom-0 py-2 cursor-pointer vcs-list-item justify-content-between"
        (click)="onProviderSelection(vcsProvider, ref)"
      >
        <span>{{ vcsProvider | titlecase }}</span>
        <nb-icon
          [icon]="vcsProvider?.toLowerCase() + '-light'"
          pack="fci"
          class="vcs-icon"
        ></nb-icon>
      </nb-list-item>
    </nb-list>
  </nb-card>
</ng-template>

<!-- VCS - (Github, Gitlab and Bitbucket) create form popup -->
<ng-template #vcsAccountIntegrationCreate let-data let-ref="dialogRef">
  <nb-card style="width: 50vw">
    <nb-card-header class="d-flex justify-content-between">
      <div class="d-flex justify-content-between align-items-center">
        <nb-icon
          class="custom-account-icon mr-2"
          pack="fci"
          [icon]="vcsAccountIcons[data?.vcsProvider]"
        ></nb-icon>
        <h6>
          {{ 'Link Your ' + (data?.vcsProvider | titlecase) + ' Account' }}
        </h6>
      </div>
      <app-close-icon [dialogRef]="ref"></app-close-icon>
    </nb-card-header>
    <nb-card-body class="pb-0">
      <app-create-vcs-app-integration-v3
        *ngIf="accountLinkingMode === 'APP'"
        [passedRef]="ref"
        vcsAccountType="{{ data?.vcsProvider }}"
        (afterSaveAccount)="onAccountsUpdate($event)"
        (afterChangeIntegration)="changeIntegrationMode($event)"
      ></app-create-vcs-app-integration-v3>
      <app-create-vcs-account-integration
        *ngIf="accountLinkingMode === 'PAT'"
        [passedRef]="ref"
        vcsAccountType="{{ data?.vcsProvider }}"
        (afterSaveAccount)="onAccountsUpdate($event)"
        (afterChangeIntegration)="changeIntegrationMode($event)"
      ></app-create-vcs-account-integration>
    </nb-card-body>
  </nb-card>
</ng-template>

<ng-template #cloudAccountCreate let-data let-ref="dialogRef">
  <nb-card style="width: 50vw">
    <nb-card-header class="d-flex justify-content-between">
      <div class="d-flex justify-content-between align-items-end">
        <nb-icon
          class="custom-account-icon mr-2"
          pack="fci"
          [icon]="cloudAccountIcons[cloudFilter]"
        ></nb-icon>
        <h6>
          {{ 'Link Your ' + (cloudFilter | titlecase) + ' Account' }}
        </h6>
        <div class="mode-switcher">
          <button
            nbButton
            size="tiny"
            [status]="authMethod === 'CREDS' ? 'primary' : 'basic'"
            [appearance]="authMethod === 'CREDS' ? 'filled' : 'outline'"
            (click)="onModeChange('CREDS')"
            (mouseenter)="currentHoveredBtn = 'CREDS'"
            nbTooltip="Fetch the values from your account and manually fill the form here."
            [nbTooltipDisabled]="currentHoveredBtn !== 'CREDS'"
          >
            <nb-icon
              icon="spanner-outline"
              pack="fci"
              [status]="authMethod === 'CREDS' ? 'outline' : 'primary'"
              style="font-size: small"
            ></nb-icon>
          </button>

          <button
            nbButton
            size="tiny"
            [status]="authMethod === 'CURL' ? 'primary' : 'basic'"
            [appearance]="authMethod === 'CURL' ? 'filled' : 'outline'"
            (click)="onModeChange('CURL')"
            (mouseenter)="currentHoveredBtn = 'CURL'"
            nbTooltip="Run the command in your account and automatically link here"
            [nbTooltipDisabled]="currentHoveredBtn !== 'CURL'"
          >
            <nb-icon
              icon="settings-2-outline"
              [status]="authMethod === 'CURL' ? 'outline' : 'primary'"
              style="font-size: small"
            ></nb-icon>
          </button>
        </div>
      </div>
      <app-close-icon [dialogRef]="ref"></app-close-icon>
    </nb-card-header>
    <nb-card-body class="pb-0">
      <ng-container *ngIf="authMethod === 'CURL'">
        <app-create-cloud-account-integration
          (afterSaveAccount)="onCloudAccountsUpdateNewFlow($event)"
          [passedRef]="ref"
          [cloudProviderType]="cloudFilter"
        ></app-create-cloud-account-integration>
      </ng-container>

      <ng-container *ngIf="authMethod === 'CREDS'">
        <app-aws-account-create-edit
          (afterSaveAccount)="onAccountsUpdate($event)"
          [passedRef]="ref"
          mode="create"
          *ngIf="cloudFilter.toUpperCase() === 'AWS'"
        ></app-aws-account-create-edit>

        <app-azure-account-create-edit
          (afterSaveAccount)="onAccountsUpdate($event)"
          [passedRef]="ref"
          mode="create"
          *ngIf="cloudFilter.toUpperCase() === 'AZURE'"
        ></app-azure-account-create-edit>

        <app-gcp-account-create-edit
          (afterSaveAccount)="onAccountsUpdate($event)"
          [passedRef]="ref"
          mode="create"
          *ngIf="cloudFilter.toUpperCase() === 'GCP'"
        ></app-gcp-account-create-edit>

        <app-kubernetes-account-create-edit
          (afterSaveAccount)="onAccountsUpdate($event)"
          [passRef]="ref"
          mode="create"
          *ngIf="cloudFilter.toUpperCase() === 'KUBERNETES'"
        >
        </app-kubernetes-account-create-edit>
      </ng-container>
    </nb-card-body>
  </nb-card>
</ng-template>
